import { createContext } from 'react';
import { HomePageSectionType } from './types';

export const HomePageSectionContext = createContext<HomePageSectionType>(
  {} as unknown as HomePageSectionType,
);
